import { Icon } from "semantic-ui-react";

import SearchInput from "components/SearchInput";
import ApplyTagsDropdown from "components/tags/ApplyTagsDropdown";
import { NewAdvancedSearch } from "components/NewAdvancedSearch";
import { getFlattenedFilters } from "components/BaseTableV3/table-helpers";
import { DownloadModal } from "components/BaseTableV3/DownloadModal";
import { LastUpdate } from "components/BaseTableV3/LastUpdate";
import { SelectedRowsCount } from "components/BaseTableV3/SelectedRowsCount";
import { BaseTableV3SettingsDrawer } from "components/BaseTableV3/BaseTableV3SettingsDrawer";
import useShowDisabledTags from "hooks/useShowDisabledTags";

import styles from "components/BaseTableV3/TableTop.module.scss";

export function TableTop({
  exportTableName,
  customTableSlug,
  downloadParams = {},
  downloadConfig = {},
  defaultFilterParams = {},
  headerIcon,
  header,
  createButton,
  enableSearch,
  searchQuery = "",
  updateSearch,
  mergeButton,
  actionButtons,
  batchEditButton,
  enableSettings,
  tableName,
  columns,
  customFields,
  customFilters = [],
  tableSettings,
  columnOrder,
  handleUpdateTableSettings,
  handleApplyAdvancedSearch,
  filters = [],
  filterParams = {},
  tagsFilters,
  selectedRowsArr = [],
  rowIdKey,
  className,
  data,
  invalidateData,
  tagsDropdownParams = { visible: false },
  tagsModelType,
  extraButtons = null,
  extra,
  isFetched = false,
  lastUpdate = null,
  handleUncheckAll,
  queryParams = {},
}) {
  const showDisabledTags = useShowDisabledTags();

  return (
    <div className={styles["table-top-container"]}>
      <div className="left-container">
        {headerIcon || header ? (
          <div className="header-container">
            {/* A string headerIcon is a Semantic icon name (the ~55 V3
                  tables); a node renders as-is so callers can supply a
                  non-Semantic glyph (e.g. a lucide custom-table icon). */}
            {typeof headerIcon === "string" ? (
              <Icon name={headerIcon} circular inverted color="orange" />
            ) : (
              headerIcon
            )}
            <span className="header-text">{header}</span>
          </div>
        ) : null}
        {createButton}
        {enableSearch ? (
          <SearchInput
            name="search"
            query={searchQuery}
            onUpdateQuery={updateSearch}
          />
        ) : null}

        {typeof extraButtons === "function"
          ? extraButtons(extra)
          : extraButtons}
        {selectedRowsArr?.length ? (
          <SelectedRowsCount
            count={selectedRowsArr?.length || 0}
            onRemove={handleUncheckAll}
          />
        ) : undefined}
      </div>
      <div className="right-container">
        {mergeButton}
        {actionButtons}
        {batchEditButton}
        {filters.length ? (
          <>
            <NewAdvancedSearch
              filters={filters}
              queryParams={queryParams}
              tableName={tableName}
              onApply={handleApplyAdvancedSearch}
            />
          </>
        ) : null}
        {tagsDropdownParams.visible ? (
          <ApplyTagsDropdown
            key={`table-tag-dropdown-${tableName}`}
            rows={data}
            modelType={tagsModelType || className}
            checkedArr={selectedRowsArr}
            onSuccess={invalidateData}
            accessor={rowIdKey}
            iconOnly
            variant={selectedRowsArr.length > 0 ? "secondary" : "outline"}
            disabled={tagsDropdownParams.disabled}
            disabledTooltip={tagsDropdownParams.disabledTooltip}
          />
        ) : null}
        {exportTableName || customTableSlug ? (
          <DownloadModal
            downloadParams={downloadParams}
            downloadConfig={downloadConfig}
            defaultFilterParams={defaultFilterParams}
            searchQuery={searchQuery}
            filters={getFlattenedFilters(filters || [])}
            filterParams={filterParams}
            customFilters={customFilters}
            tagsFilters={tagsFilters}
            exportTableName={exportTableName}
            customTableSlug={customTableSlug}
            visibleColumns={tableSettings?.visibleColumns}
            showDisabledTags={showDisabledTags}
            savedSearchName={""}
            sorted={tableSettings?.sort}
            isDisabled={!isFetched}
          />
        ) : null}
        <LastUpdate lastUpdate={lastUpdate} />
        {enableSettings ? (
          <BaseTableV3SettingsDrawer
            tableName={tableName}
            allColumns={columns}
            customFields={customFields}
            freezedColumns={tableSettings?.freezedColumns}
            visibleColumns={columnOrder}
            updateTableSettings={handleUpdateTableSettings}
            enableCustomFieldsSettings={customFields?.length > 0}
            isLoading={!isFetched}
          />
        ) : null}
      </div>
    </div>
  );
}
